<template>
    <div id="root" class="root">
        <nav id="sidebar">
            <div class="sidebar-header" style="font-size: 1.1em; display: flex; align-items: center;">
                <div style="width: 100%; text-align: center;" @click="selectMenu(0)">
                    <img src="/static/imgs/logols_w.svg" alt="menu" style="width: 30%; margin-top: 5vh; margin-bottom: 2.5vh;">
                </div>
            </div>
            <ul class="list-unstyled components" style="margin-top: 0; overflow-y: scroll; font-size: 4vw;">
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(6)">RESERVAS</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(1)">HISTÓRIA</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(2)">COMODIDADES</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(3)">LOCALIZAÇÃO</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(4)">GASTRONOMIA</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(5)">ACOMODAÇÕES</a>
                </li>
                <li>
                    <a style="font-family: 'Humanst521BT';" @click="selectMenu(7)">LS EXPERIENCE</a>
                </li>
            </ul>
        </nav>

        <div class="section" id="sidebarCollapse" @click="changeSideBar()">
            <a class="navicon-button x" id="icmenu" >
                <div class="navicon">
                </div>
            </a>
        </div>

        <div class="top-bar" :style="'margin-top: ' + topBarMargin + 'px;'">
            <span class="top-bar-item" @click="selectMenu(6)">RESERVAS</span>
            <span class="top-bar-item" @click="selectMenu(1)">HISTÓRIA</span>
            <span class="top-bar-item" @click="selectMenu(2)">COMODIDADES</span>
            <span class="top-bar-item" @click="selectMenu(3)">LOCALIZAÇÃO</span>
            <img class="top-logo_b" :style="'height: ' + logoHeight + 'vh; margin-top: ' + logoMargin + 'vh;'" src="/static/imgs/logols_marron.svg" @click="selectMenu(0)"/>
            <span class="top-bar-item" @click="selectMenu(4)">GASTRONOMIA</span>
            <span class="top-bar-item" @click="selectMenu(5)">ACOMODAÇÕES</span>
            <span class="top-bar-item">LS EXPERIENCE</span>
            <div class="top-bar-item">
                <a target="_blank" href="https://www.facebook.com/lshoteljp/"><img src="/static/imgs/ic_r_face_b.svg"/></a>
                <a target="_blank" href="https://www.instagram.com/ls_hotel/"><img src="/static/imgs/ic_r_insta_b.svg"/></a>
                <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g303428-d15241822-Reviews-Ls_Hotel-Joao_Pessoa_State_of_Paraiba.html"><img src="/static/imgs/ic_r_trip_b.svg"/></a>
            </div>
        </div>

        <div class="root_blog">
            <!--<span class="tx_blog1_destaque" style="margin-top: 15vh; margin-bottom: -10vh; background-color: transparent"> Galeria de Eventos LS </span>-->
            <!--<span class="tx_title_comodidades" style="font-weight: bold; ">Galeria de Eventos LS</span>-->
            <span class="tx_descricao tx_title_galeria" >Galeria de Eventos LS</span>

            <!-- ################ Parte 1 blog  ################ -->
            <div id="part0" class="blog1">
                <div class="blog1_p1" style="width: 100%;">
                    <span class="tx_blog1_destaque"> DESTAQUE </span>
                    <div class="dv_im_container">
                        <div v-for="(item, index) in galery_p1" :key="index" v-if="index < 3">
                            <!--<img class="im_galery" :src="item.path" :title="item.name" style="width: 20vw"/>-->
                            <img v-if="item.video" class="im_galery" :src="getYoutubeThumb(item.path)" :title="item.name" :style="'width: ' + item.width"/>
                            <img v-else class="im_galery" :src="item.path" :title="item.name" :style="'width: ' + item.width"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ################ Galeria  ################ -->
            <div id="part2" class="blog1 blog1_gal">
                <div class="blog1_p1" style="width: 100%">
                    <span class="tx_blog1_destaque"> EVENTOS </span>
                    <div class="dv_im_container">
                        <div v-for="(item, index) in galery_p1" :key="index">
                            <!--<img v-if="item.video" class="im_galery" :src="getYoutubeThumb(item.path)" :title="item.name" :style="'width: ' + item.width"/>-->
                            <iframe v-if="item.video" class="im_galery" :style="'width: ' + item.width" :src="getYoutubeIframeUrl(item.path)" :title="item.name" frameborder="0" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture;" referrerpolicy="strict-origin-when-cross-origin"></iframe>
                            <img v-else class="im_galery" :src="item.path" :title="item.name" :style="'width: ' + item.width"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ################ FOOTBAR  ################ -->
        <div id="part7" class="footbar" style="margin-top: 10vh;">
            <div class="dv_footbar_container">
                <div class="dv_footbar_colum0">
                    <span class="tx_footbar">CONTATO</span>
                    <span class="tx_footbar_desc">+55 83 3022.2460</span>
                    <span class="tx_footbar_desc">gerencia@lshotel.com.br</span>
                    <span class="tx_footbar_desc">Av. Ingá, 92 - Manaíra</span>
                    <span class="tx_footbar_desc">João Pessoa - Paraíba</span>
                </div>
                <div class="dv_footbar_colum">
                    <span class="tx_footbar" style="justify-content: center;">REDES SOCIAIS</span>
                    <div style="display: flex; align-self: center; justify-self: center; width: 100%; justify-content: center; margin-top: 5%;">
                        <a target="_blank" href="https://www.facebook.com/lshoteljp/"><img class="im_social" src="/static/imgs/ic_r_face_w.svg"/></a>
                        <a target="_blank" href="https://www.instagram.com/ls_hotel/"><img class="im_social" src="/static/imgs/ic_r_insta_w.svg"/></a>
                        <a target="_blank" href="https://www.tripadvisor.com.br/Hotel_Review-g303428-d15241822-Reviews-Ls_Hotel-Joao_Pessoa_State_of_Paraiba.html"><img class="im_social" src="/static/imgs/ic_r_trip_w.svg"/></a>
                        <a target="_blank" href="https://api.whatsapp.com/send?phone=5583991951687"><img class="im_social" src="/static/imgs/ic_whatsapp.svg"/></a>
                    </div>
                </div>
                <div class="dv_footbar_colum2" style="width: 23%;">
                    <span class="tx_footbar">FAÇA PARTE DO NOSSO MAILLING</span>
                    <input style="max-width: 100%; height: 2.5vh; margin-right: 0;" v-model="new_email" :placeholder="tx_digite_email" v-on:keyup.enter="closeKey()" onsubmit="closeKey()"/>
                    <div style="text-align: right; width: 100%;">
                        <span class="bt_enviar" @click="sendNewsletter()">ENVIAR</span>
                    </div>
                </div>
                <div class="dv_footbar_colum2" style="align-items: center; justify-content: center;">
                    <img class="top-logo" src="/static/imgs/logols_w.svg" @click="selectMenu(0)"/>
                </div>
            </div>

            <div style="width: 100%; height: 1vh; display: flex; flex-direction: row;">
                <div style="width: 25%; height: 100%; background-color: #7d6125;"/>
                <div style="width: 25%; height: 100%; background-color: var(--light-yellow);"/>
                <div style="width: 25%; height: 100%; background-color: var(--light-gray-font);"/>
                <div style="width: 25%; height: 100%; background-color: var(--dark-gray);"/>
            </div>

        </div>

        <div v-if="showPopup || showPopup2" class="popup_overlay" @click.prevent.stop="closePopup()">
            <div v-if="showPopup" class="dv_popup_mail3" onclick="event.stopPropagation();">
                <div style="display: flex; width: 100%; justify-content: flex-end;">
                    <div style="width: 3vh; height: 3vh; margin-bottom: -3vh; z-index: 20; cursor: pointer;" @click.prevent.stop="closePopup()">
                        <img src="/static/imgs/ic_fechar.svg" style="background-color: var(--light-gray-font); width: 100%; height: 100%; padding: 0.5vh; margin-left: -0.5vh; margin-top: -0.5vh;"/>
                    </div>
                </div>
                <div style="border-width: 2px; border-style: solid; border-color: var(--light-yellow); height: calc(100% - 4vh); text-align: left; padding: 2vh; display: flex; flex-direction: column; justify-content: space-between;">
                    <div style="display: flex; flex-direction: column;">
                        <span class="tx_popup1">QUER VIVER</span>
                        <span class="tx_popup1">A EXPERIÊNCIA</span>
                        <span class="tx_popup1">LS HOTEL?</span>
                    </div>

                    <!--<a target="_blank" href="https://myreservations.omnibees.com/default.aspx?q=7482" style="width: 80%; display: compact">-->
                        <!--<span class="tx_popup4">Faça sua reserva clicando aqui.</span>-->
                    <!--</a>-->
                    <div style="background-color: var(--dark-brown); display: inline-block; width: fit-content; padding: 0.5vw; cursor: pointer;" @click.prevent.stop="goToURL('https://myreservations.omnibees.com/default.aspx?q=7482')">
                        <span class="tx_popup4">Faça sua reserva</span>
                        <span class="tx_popup4">clicando aqui.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Home',
    data () {
        return {
            name: 'Blog',
            tx_digite_email: 'DIGITE AQUI SEU E-MAIL',
            logoHeight: 8,
            logoMargin: 1.5,
            sel_rest: 0,
            sel_acomodacao: 1,
            topBarMargin: 50,
            quantCriancas: 0,
            quantAdultos: 2,
            tipoSuite: 0,
            new_email: '',
            baseUrlApi: 'https://advice.domm.com.br:8445/AdviceServer/restapi/search/',
            showPopup: false,
            showPopup2: false,
            primeiraVezPopup2: true,
            galery_p1: [
                {
                    name: 'Foto 1',
                    width: '20vw',
                    path: '/static/imgs/galeria/1.jpg'
                },
                {
                    name: 'Foto 2',
                    width: '20vw',
                    path: '/static/imgs/galeria/2.jpg'
                },
                {
                    name: 'Foto 3',
                    width: '20vw',
                    path: '/static/imgs/galeria/3.jpg'
                },
                {
                    name: 'Foto 4',
                    width: '20vw',
                    path: '/static/imgs/galeria/4.jpg'
                },
                {
                    name: 'Foto 5',
                    width: '20vw',
                    path: '/static/imgs/galeria/5.jpg'
                },
                {
                    name: 'Foto 6',
                    width: '20vw',
                    path: '/static/imgs/galeria/6.jpg'
                },
                {
                    name: 'Foto 7',
                    width: '20vw',
                    path: '/static/imgs/galeria/7.jpg'
                },
                {
                    name: 'Pez 1',
                    width: '20vw',
                    path: 'rOsC8FBq6Hk',
                    video: true
                }
                // {
                //     name: 'Pez 2',
                //     width: '20vw',
                //     path: 'ZdmfEE0iGAs',
                //     video: true
                // },
                // {
                //     name: 'Pez 3',
                //     width: '20vw',
                //     path: 'uSLnnRmN0ZY',
                //     video: true
                // },
                // {
                //     name: 'Pez 4',
                //     width: '20vw',
                //     path: 'x_AuyRhfnl0',
                //     video: true
                // },
                // {
                //     name: 'Pez 11 v1',
                //     width: '20vw',
                //     path: 'k9Lu8RejqOo',
                //     video: true
                // },
                // {
                //     name: 'Pez 11 v2',
                //     width: '20vw',
                //     path: '7hHy2ycxN3A',
                //     video: true
                // },
                // {
                //     name: 'LS Ação Hospital',
                //     width: '20vw',
                //     path: 'WuT8Q7fvhrA',
                //     video: true
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/bg_home02.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/bg_home01.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/bg_home00.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/bg_home00_2023.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/bg_home03.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/bg_home03_2023.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/im_delux01.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     width: '20vw',
                //     path: '/static/imgs/im_delux02.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     path: '/static/imgs/im_delux03.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     path: '/static/imgs/im_premium01.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     path: '/static/imgs/im_premium02.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     path: '/static/imgs/im_premium03.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     path: '/static/imgs/im_presidencial01.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     path: '/static/imgs/im_presidencial02.jpg'
                // },
                // {
                //     name: 'Foto 1',
                //     path: '/static/imgs/im_presidencial03.jpg'
                // }
            ],
            weather: [],
            momentos: [],
            semanas: [
                'DOM',
                'SEG',
                'TER',
                'QUA',
                'QUI',
                'SEX',
                'SAB'
            ],
            mares_full: [],
            slidesVec1: [],
            slidesVec2: [],
            slidesCur1: 1,
            slidesCur2: 1,
            slidesClickTime: 0,
            slidesAutoTime: 5000,
            slide_home: [
                '/static/imgs/bg_home02.jpg',
                '/static/imgs/bg_home01.jpg',
                '/static/imgs/bg_home03.jpg'
            ],
            slide_deluxe: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ],
            slide_premium: [
                '/static/imgs/im_premium01.jpg',
                '/static/imgs/im_premium02.jpg',
                '/static/imgs/im_premium03.jpg'
            ],
            slide_presidencial: [
                '/static/imgs/im_presidencial01.jpg',
                '/static/imgs/im_presidencial02.jpg',
                '/static/imgs/im_presidencial03.jpg'
            ],
            slide_suites: [
                '/static/imgs/im_delux01.jpg',
                '/static/imgs/im_delux02.jpg',
                '/static/imgs/im_delux03.jpg'
            ],
            loading: {
                weather: false,
                momento: false,
                feed: false,
                mare: false
            },
            offsetLeft: 0,
            lastIn: 1
        }
    },
    methods: {
        getYoutubeThumb (videoId) {
            return 'https://img.youtube.com/vi/' + videoId + '/0.jpg'
        },
        getYoutubeIframeUrl (videoId) {
            return 'https://www.youtube.com/embed/' + videoId + '?si=OYCsk5Yah-DN-xpc&amp;controls=0'
        },
        gotoYoutbe (videoId) {
            this.goToURL('https://youtu.be/' + videoId)
        },
        prepareGaleryWidth () {
            let i
            for (i = 0; i < this.galery_p1.length; i++) {
                // if (i % 3 === 0) {
                if ((i % 3 === 0 && this.lastIn % 3 !== 0) ||
                    i % 5 === 0 ||
                    i === this.galery_p1.length - 1) {
                    this.lastIn = i
                    this.galery_p1[i].width = '30vw'
                } else {
                    this.galery_p1[i].width = '20vw'
                }
            }
        },
        getImgGalWidth (index) {
            if ((index % 3 === 0 && this.lastIn % 3 !== 0) ||
                index % 6 === 0) {
                this.lastIn = index
                return '30vw'
            } else {
                return '20vw'
            }
        },
        changeSideBar () {
            // console.log('entrei no changeSideBar')
            window.$('#icmenu').toggleClass('open')
            if (!window.$('#sidebar').hasClass('active')) {
                window.$('.overlay').fadeIn()
                window.$('.collapse.in').toggleClass('in')
                window.$('a[aria-expanded=true]').attr('aria-expanded', 'false')
            } else {
                window.$('.overlay').fadeOut()
            }
            window.$('#sidebar').toggleClass('active')
        },
        scrollEstabs (right, inc) {
            var incre
            var vm = this
            // console.log('scrollEstabs: ', el)
            // console.log('inc: ', inc)

            if (inc === undefined) {
                incre = 150
            } else {
                incre = inc
            }
            // console.log('incre: ', incre);
            // console.log('scrollEstabs:el.offset ', el.offset());
            // console.log('scrollEstabs:el.width  ', el.width());

            if (right) {
                this.offsetLeft += incre
                console.log('this.elScroll.width() * 1.6: ', this.elScroll.width() * 1.6)
                console.log('this.offsetLeft: ', this.offsetLeft)
                if (this.offsetLeft > this.elScroll.width() * 1.6) {
                    this.offsetLeft = this.elScroll.width() * 1.6
                }
            } else {
                this.offsetLeft -= incre
                if (this.offsetLeft < 0) {
                    this.offsetLeft = 0
                }
            }

            if (incre < 50) {
                // faz rapido
                this.elScroll.scrollLeft(this.offsetLeft)

                vm.$nextTick(function () {
                    setTimeout(function () {
                        if ((vm.elLeft.is(':hover') && !right) || (vm.elRight.is(':hover') && right)) {
                            vm.scrollEstabs(right, 15)
                        }
                    }, 100)
                })
            } else {
                // faz suave
                this.elScroll.animate({'scrollLeft': this.offsetLeft}, 500)
            }
        },
        reservar () {
            var mes1 = '' + (this.calendario1.mes + 1)
            var mes2 = '' + (this.calendario2.mes + 1)
            if (mes1 < 10) {
                mes1 = '0' + (this.calendario1.mes + 1)
            }
            if (mes2 < 10) {
                mes2 = '0' + (this.calendario2.mes + 1)
            }
            var dia1 = this.calendario1.dia
            // console.log('dia1 len: ' + typeof dia1)
            // console.log('dia1 len: ' + dia1.size())
            var dia2 = this.calendario2.dia
            if (dia1 < 10) {
                dia1 = '0' + dia1
            }
            if (dia2 < 10) {
                dia2 = '0' + dia2
            }

            var dataIn = dia1 + mes1 + this.calendario1.ano
            var dataOut = dia2 + mes2 + this.calendario2.ano

            console.log('Datain ', dataIn)
            console.log('Dataout ', dataOut)

            var url = 'https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=' + dataIn + '&CheckOut=' + dataOut + '&Code=&group_code=&loyality_card=&NRooms=1&ad=' + this.quantAdultos + '&ch=' + this.quantCriancas + '&ag=-'
            // https://myreservations.omnibees.com/default.aspx?q=7482#/&diff=false&CheckIn=02122020&CheckOut=19122020&Code=&group_code=&loyality_card=&NRooms=1&ad=1&ch=0&ag=-
            console.log('url: ' + url)
            this.goToURL(url)
        },
        closePopup () {
            if (this.showPopup) {
                this.showPopup = false
            } else {
                this.showPopup2 = false
            }
        },
        closeKey () {
            console.log('closeKeyboard')
            this.sendNewsletter()
        },
        selectRestaurante (i) {
            this.sel_rest = i
        },
        selectAcomodacao (i) {
            this.sel_acomodacao = i
            switch (i) {
            case 1: this.slide_suites = this.slide_deluxe; break
            case 2: this.slide_suites = this.slide_premium; break
            case 3: this.slide_suites = this.slide_presidencial; break
            }
        },
        selectMenu (i) {
            console.log('selectMenu: ' + i)

            if (this.isMobile()) {
                this.changeSideBar()
            }

            this.$router.push({params: {menuIndex: i}, name: '/'})
        },
        addEvent (obj, type, fn) {
            if (obj.attachEvent) {
                obj['e' + type + fn] = fn
                obj[type + fn] = function () { obj['e' + type + fn](window.event) }
                obj.attachEvent('on' + type, obj[type + fn])
            } else {
                obj.addEventListener(type, fn, false)
            }
        },
        isMobile () {
            if (window.innerWidth < 861) {
                return true
            } else {
                return false
            }
        },
        handleScrool (event) {
            // console.log('el.scrollHeight ', this.elPart0.scrollHeight)
            // console.log('event ', window.scrollY)

            if (this.isMobile()) {
                this.logoHeight = 5
                this.topBarMargin = 0
                this.logoMargin = 0
                return
            }

            if (window.scrollY > this.elPart0.scrollHeight) {
                this.topBarMargin = 0
                this.logoHeight = 5
                this.logoMargin = 0
            } else {
                let diff = this.elPart0.scrollHeight - window.scrollY
                this.topBarMargin = Math.round(diff * 0.05)
                let p = diff / this.elPart0.scrollHeight
                this.logoHeight = 4 + 4 * p
                this.logoMargin = 1.5 * p
                // console.log('this.elPart0.scrollHeight: ', this.elPart0.scrollHeight)
                // console.log('window.scrollY: ', window.scrollY)
                // console.log('diff: ', diff)
                // console.log('percentual: ', p)
            }
            // console.log('logoHeight: ', this.logoHeight)
            // console.log('logoMargin: ', this.logoMargin)
        },
        goToURL (url) {
            window.open(url, '_blank')
            // location.href = url
        },
        checkEmail () {
            var email = this.new_email
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        sleep (time) {
            return new Promise((resolve) => setTimeout(resolve, time))
        },
        moveSlide (index, right, manualClick = true) {
            console.log('moveSlide' + index)
            var currTime = Date.now()
            var slidesVec
            var slidesCur
            if (manualClick) {
                this.bannerAutoSlide = true
            }

            if (currTime - this.slidesClickTime < 700) {
                console.log('moveSlide::return because time interval is too short')
                return
            }

            if (!manualClick && (currTime - this.slidesClickTime < this.slidesAutoTime)) {
                console.log('moveSlide::tempo de espera errado.')
                return
            }

            if (!this.bannerAutoSlide) {
                console.log('moveSlide::Nao eh para momento do auto slide.')
                return
            }

            if (index === 1) {
                slidesVec = this.slidesVec1
                slidesCur = this.slidesCur1
            } else {
                slidesVec = this.slidesVec2
                slidesCur = this.slidesCur2
            }

            this.slidesClickTime = currTime

            console.log('moveSlide::Movendo slide para: ' + right + ', manualClick: ' + manualClick + ', bannerAutoSlide: ' + this.bannerAutoSlide)
            // Get all the slides again
            var slides = window.$('.slide' + index)
            // console.log('slides: ', slides)

            // Register active slide
            // var activeSlide = $('.active');
            var activeSlide = slidesVec[slidesCur]

            // Next function
            if (right) {
                slidesCur = (slidesCur + 1) % slidesVec.length

                // Move first slide to the end so the user can keep going forward
                slides.last().after(slides.first())
                // Move active class to the right
                activeSlide.removeClass('active').next('.slide' + index).addClass('active')
            } else {
                slidesCur--
                if (slidesCur < 0) {
                    slidesCur = slidesVec.length - 1
                }

                // Move the last slide before the first so the user can keep going backwards
                slides.first().before(slides.last())
                // Move active class to the left
                activeSlide.removeClass('active').prev('.slide' + index).addClass('active')
            }

            if (index === 1) {
                this.slidesVec1 = slidesVec
                this.slidesCur1 = slidesCur
            } else {
                this.slidesVec2 = slidesVec
                this.slidesCur2 = slidesCur
            }

            if (this.bannerAutoSlide) {
                var vm = this
                setTimeout(function () {
                    vm.moveSlide(index, true, false)
                }, vm.slidesAutoTime)
            }
        },
        prepareSlider () {
            // Get all the slides again
            var vec = window.$('.slide1')
            this.slidesVec1.push(vec.first())
            this.slidesVec1.push(vec.first().next())
            this.slidesVec1.push(vec.last())
            vec = window.$('.slide2')
            this.slidesVec2.push(vec.first())
            this.slidesVec2.push(vec.first().next())
            this.slidesVec2.push(vec.last())

            // console.log('this.slidesVec: ', this.slidesVec)

            // this.mobile = this.isMobile()

            var vm = this
            setTimeout(function () {
                vm.moveSlide(1, true, true)
            }, vm.slidesAutoTime)
        },
        getSemana (i) {
            return this.semanas[(this.indexDia + i) % 7]
        }
    },
    created () {
        console.log('Saindo do Created')

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0
        }

        this.prepareGaleryWidth()

        var dt = new Date()
        this.indexDia = dt.getDay()
        this.ano = dt.getFullYear() - 2000
        this.mes = dt.getMonth()
        this.dia = dt.getDate()
    },
    mounted () {
        console.log('Entrando do Mounted')
        global.jQuery = require('jquery')
        window.$ = global.jQuery

        this.elScroll = window.$('#scrollhorizontal')
        this.elRight = window.$('#scrollright')
        this.elLeft = window.$('#scrollleft')
        this.elPart0 = document.getElementById('part0')

        if (this.isMobile()) {
            this.logoHeight = 5
            this.topBarMargin = 0
            this.logoMargin = 0
        } else {
            this.topBarMargin = Math.round(this.elPart0.scrollHeight * 0.05)
            this.logoHeight = 8
            this.logoMargin = 1.5
        }

        this.addEvent(window, 'scroll', this.handleScrool)

        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0

        console.log('Saindo do Mounted')
    }
}
</script>

<style src="../assets/css/side_bar.css" scoped/>
<style src="../assets/css/menu_icon.css" scoped/>
<style src="../assets/css/ls.css" scoped/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Galery.vue